import { useQuery } from '@tanstack/react-query';
import { getTransactionsReportSummary } from 'config/requests/transactionsReport';
import { TransactionsReportSummary } from 'types/embedded/transactionsReportSummary';

import { OrdersListFilterFormValues } from '../OrdersList/OrdersListContent';

type ReturnValue = {
  isLoading: boolean;
  isFetching: boolean;
  refetch: VoidFunction;
  data?: TransactionsReportSummary;
};

export type TransactionsReportFormValues = Omit<OrdersListFilterFormValues, 'gateway.provider'>;

type Props = {
  filters: TransactionsReportFormValues;
};

export function useGetTransactionsReportSummary({ filters }: Props): ReturnValue {
  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ['transactions_report_summary', filters],
    queryFn: () => getTransactionsReportSummary(filters),
    enabled: !!filters,
  });

  return {
    data,
    isLoading,
    isFetching,
    refetch,
  };
}
